<!-- rota: /fatura/gelenEFaturaIsle/:id  (name: fatura-EFaturaIsle) -->
<template>
  <basepage
    title="Gelen e-Fatura İşleme"
    :status="status"
    :menuitems="menuItems"
    v-on:menuclick="menuClick"
  >
    <template slot="toolbar">
      <!--
    <v-text-field v-model="aranacak" flat="" solo-inverted="" hide-details :label="this.$t('Search')" append-icon="search"></v-text-field>
    <v-btn :disabled="status.loading" flat @click="kayitgetir()">Ara</v-btn>
    -->
    </template>

    <div>
      <v-card class="mx-auto" max-width="800">
        <v-card-title class="title font-weight-regular justify-space-between">
          <span>{{ currentTitle }}</span>
          <v-avatar
            color="primary lighten-2"
            class="subheading white--text"
            size="24"
            v-text="step"
          ></v-avatar>
        </v-card-title>

        <v-window v-model="step">
          <v-window-item :value="1">
            <v-card-text>
              <v-radio-group v-model="ModulRadioGroup">
                <v-radio :label="$t('Free-Invoice')" :value="1"></v-radio>
                <v-radio :label="$t('Ticket-Underway')" :value="2"></v-radio>
                <v-radio label="Coper" :value="3"></v-radio>
              </v-radio-group>
              <span class="caption grey--text text--darken-1">
                {{ $t('Select-Module-which-Received-E-Invoice-will-transferred') }}
              </span>
            </v-card-text>
          </v-window-item>

          <v-window-item :value="2">
            <v-card-text v-if="ModulRadioGroup == 1">
              <caricomp
                v-bind:etiket="$t('Select-Current-Account')"
                v-bind:value="CariKod"
                v-model="CariKod"
                v-bind:Coper="ModulRadioGroup == 3"
              ></caricomp>

              <masrafmerkezicomp v-model="MasrafMerkezi">
              </masrafmerkezicomp>

              <br />

              <span class="caption grey--text text--darken-1">
                {{ CariKartSecmeAciklamasi() }}
              </span>
            </v-card-text>
          
            <v-card-text v-if="ModulRadioGroup == 3">
             
              <pnrbul v-model="PNR_No"> </pnrbul>
           
            </v-card-text>
          
          </v-window-item>

          <v-window-item :value="3">
            <v-card-text>
              <v-btn
                :disabled="UzerineYazmaOnayi == false"
                color="primary"
                depressed
                @click="SerbestFaturaKaydet(true)"
              >
                Mevcut Faturanın üzerine tekrar yaz
              </v-btn>

              <v-checkbox
                v-model="UzerineYazmaOnayi"
                :label="$t('I-approve-re-writing-existing-invoice')"
              ></v-checkbox>

              <br />
              <br />

              <span class="caption grey--text text--darken-1">
                {{ $t('Invoice-Transfer-has-been-Completed') }}
                <br />
                {{ $t('Please-Check-Correctness-Invoice-Received') }}
                <br />
                 {{ $t('Please-Contact-Arkman-Software-case-missing-wrongful-data') }} 
              </span>
            
            </v-card-text>

           



          </v-window-item>




        </v-window>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn :disabled="step === 1" flat @click="BackStep()"> Back </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="(step === 3) || (step === 4)  "
            color="primary"
            depressed
            @click="NextStep()"
          >
            Next
          </v-btn>
        </v-card-actions>
      </v-card>

      <!-- E-fatura baska cariye aktarilmis: sunucunun mesaji ve kayitli faturayi yeni sekmede acan link. -->
      <v-dialog v-model="baskaCariDialog" max-width="560px">
        <v-card data-test="gelen-baska-cari-dialog">
          <v-card-title class="title">{{ $t('E-Invoice-Already-Transferred') }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div data-test="gelen-baska-cari-mesaj">{{ baskaCariMesaj }}</div>
            <div v-if="kayitliFatura" class="mt-3">
              <a :href="kayitliFaturaAdresi" target="_blank" data-test="gelen-baska-cari-fatura-ac">
                {{ $t('Open-Transferred-Invoice') }}: {{ kayitliFatura.CariKod }} - {{ kayitliFatura.FaturaSeri }}/{{ kayitliFatura.FaturaNo }}
                - {{ $t('Invoice-Date') }}: <span data-test="gelen-baska-cari-fatura-tarihi">{{ kayitliFaturaTarihi }}</span>
              </a>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" data-test="gelen-baska-cari-kapat" @click="baskaCariDialog = false">
              {{ $t('Close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--
      <code>
        {{ response }}
      </code>
      <v-divider></v-divider>
      <code>
        {{ Response_TCKN_VKN_CarisiBul }}
      </code>
-->
      <br />
      <v-divider></v-divider>
      <br />
      <div>
        <v-card>
          <div v-html="html"></div>
        </v-card>
      </div>
    </div>
  </basepage>
</template>

<script>
import basepage from "@/components/app/coper/comp/basepage.vue";
import tool from "@/components/app/coper/tools.js";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihcomp from "@/components/app/customcomp/tarihim";
import caricomp from "@/components/app/customcomp/caricomp";
import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
import pnrbul from "@/components/app/coper/component/pnrbul.vue";


export default {
  components: {
    basepage,
    tarihcomp,
    caricomp,
    masrafmerkezicomp,
    pnrbul,
  },
  data() {
    return {
      status: tool.NewSatatus(),
      UUID: null,
      PNR_No:"",
      // Fatura baska bir Coper sirketine aitse doldurulan uyari metni.
      // Bos oldugu surece islemeye devam edilebilir.
      sirketUyari: null,
      response: [],
      step: 1,
      ModulRadioGroup: 1,
      UzerineYazmaOnayi: false,

      // E-fatura baska cariye aktarilmissa sunucunun mesaji ve kayitli fatura (uyari dialogu).
      baskaCariDialog: false,
      baskaCariMesaj: "",
      kayitliFatura: null,

      Response_TCKN_VKN_CarisiBul: null,
      CariKod: "",
      MasrafMerkezi:"",
      html:"",

      aranacak: "",
      menuItems: [
        {
          title: "---",
        },
      ],
    };
  },
  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return this.$t('Module-Selection');
        case 2:
          if (this.ModulRadioGroup == 3)
          {
            return 'PNR Seçimi'
          }else{
            return this.$t('Matching-Currents-Received-Invoices');
          }
         
        default:
          return this.$t('Invoice-Saved');
      }
    },

    /**
     * E-fatura baska cariye aktarilmissa o faturanin serbest fatura (gelen evrak) adresi.
     * Bicim gelen fatura listesindeki "git" ile ayni (gelenfaturalistesi.vue); degerler
     * kodlaniyor: cari kodunda bosluk ve Turkce karakter olabiliyor.
     */
    kayitliFaturaAdresi() {
      var f = this.kayitliFatura;
      if (!f) {
        return "";
      }
      return "#/fatura/serbestfatura/id?ft=" + encodeURIComponent(f.FaturaTarih) +
        "&ck=" + encodeURIComponent(f.CariKod) + "&et=null" +
        "&es=" + encodeURIComponent(f.FaturaSeri || "") +
        "&en=" + encodeURIComponent(f.FaturaNo) +
        "&ner=X&sb=false&islem=gelenevrak";
    },

    // Kayitli faturanin tarihi gg.aa.yyyy (saat dilimi kaydirmasin diye ISO metinden).
    kayitliFaturaTarihi() {
      return this.kayitliFatura ? helpers.isoTarihiBicimle(this.kayitliFatura.FaturaTarih) : null;
    },
  },
  watch: {
    step(val) {
      this.step = val;
      switch (val) {
        case 1:
          break;
        case 2:
          //this.VKNCariBul();
          break;
        case 3:
          if (this.ModulRadioGroup == 1) {
            //this.SerbestFaturaKaydet(false);
          }
          break;
      }
    },

    ModulRadioGroup(val) {
      this.ModulRadioGroup = val;
      this.CariKod = "";
      // Coper tiki isaretlenir isaretlenmez dogrula.
      if (val == 3) {
        this.coperSirketKontrol();
      }
    },

    // PNR secme adiminda da dogrulaniyor: kullanicinin hatayi bir sonraki
    // adimda degil, secim aninda gormesi gerekiyor.
    PNR_No() {
      this.coperSirketKontrol();
    },
  },
  methods: {
    menuClick(index) {
      if (index == 0) {
        //TODO : Entegratör Ayar sayfası açılacak
      }
    },

    /**
     * Islenen e-fatura aktif Coper sirketine mi ait?
     *
     * Havuz listesi zaten "where CariSirketNo=@CariSirketNo" ile filtreli,
     * yani normalde kullanici yalnizca kendi aktif sirketinin faturalarini
     * gorur. Uyusmazlik su durumda olusuyor: sayfa bir sekmede acikken
     * baska bir sekmede Coper sirketi degistiriliyor.
     *
     * Aktif sirket CoperCariSirketBul ucundan geliyor. Uc ayrica sorgu
     * YAPMIYOR; CoperData yapicisi zaten GetCoperCariSirket ile eslemeyi
     * yapip LoginInfo.CariSirket'i dolduruyor, uc yalnizca o degeri aciyor.
     *
     * Bu kontrol olmadan devam edildiginde GetInvoiceHtml, PNR'nin
     * persondetails kaydini aktif sirkette bulamiyor ve anlamsiz bir hata
     * donuyordu.
     */
    coperSirketKontrol() {
      this.sirketUyari = null;

      // Fatura henuz yuklenmediyse karsilastiracak bir sey yok.
      if (!this.response || !this.response.CariSirketNo) {
        return Promise.resolve(true);
      }

      var faturaCariSirket = this.response.CariSirketNo;

      return tool.http_post(this, "CoperCariSirketBul", {}).then(
        (response) => {
          if (faturaCariSirket == response.body.CariSirketNo) {
            return true;
          }

          this.sirketUyari =
            "Aktif Coper şirketi, bu faturanın ait olduğu Cari şirkete bağlı değil. " +
            "Lütfen doğru Coper şirketini aktif edip tekrar deneyin.";
          this.status.text = this.sirketUyari;
          this.status.show = true;
          return false;
        },
        (response) => {
          this.status = tool.responseToStatus(response);
          return false;
        }
      );
    },


    coperGelenfaturaEkle() {
        // Ikinci savunma hatti: watch tetiklenmemis olabilir (ornegin PNR
        // programatik atanmissa), o yuzden acmadan once tekrar dogrulaniyor.
        this.coperSirketKontrol().then((uygun) => {
          if (uygun !== true) { return }

          var url = '#/fatura/copergelenfatura/id?islem=yeni&uuid='+this.UUID+"&pnrno="+this.PNR_No
          window.open(url, '_blank')
        });
    },

    Durum(val) {
      if ((val.AktarimTarihi = "0001-01-01T00:00:00")) {
        return "Bekliyor";
      } else {
        return this.$t('Processed');
      }
    },

    kayitgetir() {},

    GetHtml: GetHtml,
    VKNCariBul: VKNCariBul,
    CariKartSecmeAciklamasi: CariKartSecmeAciklamasi,
    SerbestFaturaKaydet: SerbestFaturaKaydet,
    NextStep,
    BackStep,
  },

  beforeMount: beforeMount,
};

function NextStep() {
  switch (this.step) {
    case 1:
      if (this.ModulRadioGroup == 1) {
        this.step = 2;
        this.VKNCariBul();
      }else if((this.ModulRadioGroup == 3)){
        //this.coperGelenfaturaEkle();
        this.step = 2;
        
      }
      break;
    case 2:
      if (this.ModulRadioGroup == 1) {
        this.SerbestFaturaKaydet(false);
      }
      if (this.ModulRadioGroup == 3) {
        this.coperGelenfaturaEkle();
      }

      break;
  }
}

function BackStep() {
  
    this.step--;
  
}

function beforeMount() {
  this.UUID = this.$route.query.uuid;
  this.GetHtml();
}

function CariKartSecmeAciklamasi() {
  if (
    this.Response_TCKN_VKN_CarisiBul == null ||
    this.Response_TCKN_VKN_CarisiBul.length == 0
  ) {
    return this.$t('TID-TCID-v3');
  } else if (
    this.Response_TCKN_VKN_CarisiBul != null &&
    this.Response_TCKN_VKN_CarisiBul.length > 1
  ) {
    return this.$t('TID-TCID-v2');
  } else if (
    this.Response_TCKN_VKN_CarisiBul != null &&
    this.Response_TCKN_VKN_CarisiBul.length == 1
  ) {
    return this.$t('TID-TCID-v1')
  }
}

function VKNCariBul() {
  if (this.CariKod == null || this.CariKod == "") {
    this.status.loading = true;
    setTimeout(() => {
      var prm = {
        Tckn_Vkn: this.response.VknTcknNo,
        isCoper: this.ModulRadioGroup == 3,
      };
      tool.api_post(this, "EFatura/TCKN_VKN_CarisiBul", prm).then(
        (response) => {
          this.status.loading = false;

          if (response.body.Status == true) {
            this.Response_TCKN_VKN_CarisiBul = response.body.data;

            if (response.body.data.length > 0) {
              this.CariKod = response.body.data[0].Kod;
            }
          } else {
            this.status.text = response.body.ErrorList[0];
            this.status.show = true;
          }
        },
        (response) => {
          this.status = tool.responseToStatus(response);
        }
      );
    }, 500);
  }
}

function SerbestFaturaKaydet(uzerineYaz) {
  this.status.loading = true;
  setTimeout(() => {
    var prm = {
      UUID: this.UUID,
      CariKod: this.CariKod,
      MasrafMerkezi:this.MasrafMerkezi,
      Update: uzerineYaz,
    };
    tool.api_post(this, "EFatura/SerbestFaturaKaydet", prm).then(
      (response) => {
        this.status.loading = false;

        if (response.body.Status == true) {
          this.status.text = "Gelen Fatura Kaydedildi";
          this.status.show = true;
          this.step = 3;
        } else {
          var veri = response.body.data || {};
          var mesaj = (response.body.ErrorList || []).join(" | ");

          // E-fatura baska cariye aktarilmis: mesaj dialogda, kayitli faturayi acan linkle.
          if (veri.KayitliFatura) {
            this.kayitliFatura = veri.KayitliFatura;
            this.baskaCariMesaj = mesaj;
            this.baskaCariDialog = true;
            return;
          }

          this.status.text = mesaj;
          this.status.show = true;
          // Havuzda fatura bulunamazsa SerbestFaturaSave gelmiyor; onceden burada hata firlatiyordu.
          if (veri.SerbestFaturaSave && veri.SerbestFaturaSave.SaveID == -1) {
            this.step = 3;
          }
        }
      },
      (response) => {
        this.status = tool.responseToStatus(response);
      }
    );
  }, 500);
}

function GetHtml() {
  this.status.loading = true;
  setTimeout(() => {
    var prm = {
      UUID: this.UUID,
    };
    tool.api_post(this, "EFatura/GetInvoiceHtml", prm).then(
      (response) => {
        this.status.loading = false;

        if (response.body.Status == true) {
          this.response = response.body.data;
          //document.getElementById("demo").innerHTML =
          //  response.body.data.InvoiceHtlm;
            this.html=response.body.data.InvoiceHtlm;
        } else {
          this.status.text = response.body.ErrorList[0];
          this.status.show = true;
        }
      },
      (response) => {
        this.status = tool.responseToStatus(response);
      }
    );
  }, 500);
}
</script>
